var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreenFreeCancellation = function SvgGreenFreeCancellation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78699 15L9.66495 13.4318C11.0189 12.6934 12.1123 11.5554 12.7962 10.1731C13.48 8.79071 13.7211 7.23114 13.4865 5.70682L12.9234 2.04545C8.83245 2.04545 6.78699 0 6.78699 0C6.78699 0 4.74154 2.04545 0.65063 2.04545L0.087448 5.70545C-0.147409 7.22999 0.0935162 8.78986 0.77739 10.1725C1.46126 11.5551 2.55482 12.6933 3.90904 13.4318L6.78699 15Z",
    fill: "url(#paint0_linear_9166_1371)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42297 10.2272C5.24216 10.2271 5.06876 10.1553 4.94093 10.0274L3.57729 8.66376C3.51217 8.60087 3.46023 8.52563 3.4245 8.44245C3.38876 8.35926 3.36995 8.2698 3.36917 8.17926C3.36838 8.08873 3.38563 7.99895 3.41991 7.91516C3.4542 7.83137 3.50482 7.75524 3.56884 7.69122C3.63286 7.6272 3.70898 7.57658 3.79278 7.54229C3.87657 7.50801 3.96635 7.49076 4.05688 7.49155C4.14741 7.49233 4.23688 7.51114 4.32007 7.54688C4.40325 7.58261 4.47849 7.63455 4.54138 7.69967L5.42297 8.58126L9.03184 4.9724C9.16043 4.8482 9.33266 4.77948 9.51143 4.78103C9.6902 4.78259 9.86121 4.85429 9.98762 4.98071C10.114 5.10712 10.1857 5.27813 10.1873 5.4569C10.1889 5.63567 10.1201 5.8079 9.99593 5.93649L5.90502 10.0274C5.77718 10.1553 5.60379 10.2271 5.42297 10.2272Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9166_1371",
    x1: 6.78699,
    y1: -0.0579545,
    x2: 6.78699,
    y2: 15.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D7C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27F42C"
  })))));
};
export default SvgGreenFreeCancellation;